'use strict';

/* eslint-disable global-require */

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./patch.prod');
} else {
  module.exports = require('./patch.dev');
}


//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/lib/patch.js
// module id = 14
// module chunks = 0